import { useState, useEffect } from "react";
import PagedListModel from "../../../models/common/PagedListModel";
import { SortDirection } from "../../../models/enums/SortDirectionEnum";
import modalUtils from "../../../utils/modal-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import RatingDetailsPopUp from "../../candidate/dashboard/RatingDetailsComponent";
import { PagingEnum } from "../../../models/enums/IAIEnum";
import AllProfilesGridModel from "../../../models/company/allProfiles/response/AllProfilesGridModel";
import AllProfilesSearchInputModel from "../../../models/company/allProfiles/request/AllProfilesSearchInputModel";
import companyDashboardService from "../../../services/company/dashboard-service";
import adminDashboardService from "../../../services/admin/admin-dashboard-service";
import AllProfilesGridComponent from "./AllProfilesGridComponent";
import CandidateHistoryPopup from "../../admin/candidate/candidate-history/CandidateHistoryComponent";
import ZoomRecordingsPopUp from "./ZoomRecordingsComponent";
import dateTimeUtils from "../../../utils/date-utils";
import fileUtils from "../../../utils/file-utils";
import ScheduleInterviewCompanyRequestModel from "../../../models/company/addProfiles/request/ScheduleInterviewCompanyRequestModel";
import addProfilesService from "../../../services/company/add-profiles-service";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import AddProfilesStatusUpdateModel from "../../../models/company/addProfiles/request/AddProfilesStatusUpdateModel";
import StatusUpdatePopUp from "../add-profiles/StatusUpdateComponent";

interface AllProfilesProps {
    primarySkillList: IdNameModel[];
    statusList: IdNameModel[];
    profileId: string[];
    userId: string;
    startDateSearch: Date;
    endDateSearch: Date;
    primarySkillSearch: number;
    isRated: boolean;
};

const AllProfilesComponent = (props: AllProfilesProps) => {
    const [candidatePagedList, setCandidatePagedList] = useState<PagedListModel<AllProfilesGridModel>>();
    const [candidateList, setCandidateList] = useState<AllProfilesGridModel[]>([]);
    const [refreshCandidate, setRefreshCandidate] = useState<number>(2);
    const [nameFilter, setNameFilter] = useState<string>("");
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CreatedDate");
    const [sortDirection, setSortDirection] = useState<number>(SortDirection.Desc);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);
    const [timeSlots, setTimeSlots] = useState<IdNameModel[]>([]);

    useEffect(() => {
        loadPageSizes();
        getTimeSlots();
        getCandidates(getSearchFilters(nameFilter, page, pageSize, sortColumn, sortDirection, false));
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (nameFilter: string, page: number, pageSize: number, sortColumn: string, sortDirection: number, isExport: boolean) => {
        var inputData: AllProfilesSearchInputModel = {
            startDate: dateTimeUtils.getFormattedDate(props.startDateSearch),
            endDate: dateTimeUtils.getFormattedDate(props.endDateSearch),
            primarySkillId: props.primarySkillSearch,
            companyIds: props.profileId,
            userId: props.userId,
            requirementIds: [],
            createdByIds: [],
            isExport: isExport,
            isRated: props.isRated,
            candidateName: nameFilter,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getCandidates = (inputData: AllProfilesSearchInputModel) => {
        setRefreshCandidate(2);
        modalUtils.showLoader();
        companyDashboardService.getAllProfilesGrid(inputData).then((res) => {
            modalUtils.closeModal();
            setCandidateList([]);
            setCandidatePagedList(res);
            setCandidateList(res.items);
            setRefreshCandidate(refreshCandidate * 5);
        }).catch((error) => {
            setRefreshCandidate(refreshCandidate * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const getCandidatesExport = (inputData: AllProfilesSearchInputModel) => {
        modalUtils.showLoader();
        companyDashboardService.getAllProfilesExport(inputData).then((res) => {
            modalUtils.closeModal();
            // if (res && (!res.isSuccess || res.errorMessages.length > 0)) {
            //     toasterUtils.showError(res.errorMessages.toString());
            //     return;
            // }
            fileUtils.downloadFile(res, "AllProfiles.xlsx");
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const getTimeSlots = () => {
        masterDataService.loadTimeSlots().then((res) => {
            if (res.isSuccess) {
                setTimeSlots(res.items);
            } else {
                toasterUtils.showError("Unable to load Primary skills");
            }
        }).catch((error) => {
            toasterUtils.showError("Erorr fetching Primary skills");
        });
    };

    const onViewRatingActionHandler = (interviewId: string) => {
        modalUtils.showLoader();
        adminDashboardService.interviewRatingDetails(interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: "Feedback Report",
                    content: (
                        <RatingDetailsPopUp objRatingDetails={res.data} />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Eror fetching Schedules");
        });
    };

    const onViewRecordingsActionHandler = (zoomScheduleId: string) => {
        modalUtils.showLoader();
        companyDashboardService.getZoomRecordings(zoomScheduleId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: "Zoom Recordings",
                    content: (
                        <ZoomRecordingsPopUp recordingsList={res.items} />
                    ),
                    size: ModalSize.LG,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Eror fetching Schedules");
        });
    };

    const onCandidateViewHistoryHandler = (candidateId: string) => {
        const config: GeneralPoupConfig = {
            title: "Candidate History",
            content: (
                <CandidateHistoryPopup
                    candidateId={candidateId} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getCandidates(getSearchFilters(nameFilter, newPage, pageSize, sortColumn, sortDirection, false));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getCandidates(getSearchFilters(nameFilter, PagingEnum.page, newPageSize, sortColumn, sortDirection, false));
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getCandidates(getSearchFilters(nameFilter, page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc, false));
    };

    const onFilterActionHandler = (filterColumn: string, filterValue: string) => {
        setPage(0);
        setNameFilter(filterValue);
        getCandidates(getSearchFilters(filterValue, 0, pageSize, sortColumn, sortDirection, false));
    };

    const onScheduleInterviewActionHandler = (objScheduleInterview: ScheduleInterviewCompanyRequestModel) => {
        setRefreshCandidate(2);
        modalUtils.showLoader();
        addProfilesService.scheduleInterview(objScheduleInterview).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getCandidates(getSearchFilters(nameFilter, page, pageSize, sortColumn, sortDirection, false));
            modalUtils.closeModal();
        }).catch((error) => {
            setRefreshCandidate(refreshCandidate * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onStatusUpdateActionHandler = (objProfile: AllProfilesGridModel) => {
        let statusUpdateRequestModel: AddProfilesStatusUpdateModel = {
            profileId: objProfile.profileId,
            userId: GuidEnum.Empty,
            statusId: objProfile.statusId,
            comments: objProfile.comments,
            followUpDate: new Date()
        };
        openStatusUpdateModel(statusUpdateRequestModel);
    };

    /* Start - Status Update Flow */
    const openStatusUpdateModel = (statusUpdateRequestModel: AddProfilesStatusUpdateModel) => {
        const config: GeneralPoupConfig = {
            title: "Update Status",
            content: (
                <StatusUpdatePopUp
                    objStatusUpdate={statusUpdateRequestModel}
                    statusList={props.statusList}
                    onCloseStatusUpdate={onCloseStatusUpdateHandler}
                    onStatusUpdate={onStatusUpdateHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseStatusUpdateHandler = () => {
        modalUtils.closeModal();
    };

    const onStatusUpdateHandler = (objStatusUpdate: AddProfilesStatusUpdateModel) => {
        setRefreshCandidate(2);
        modalUtils.showLoader();
        addProfilesService.updateProfileStatus(objStatusUpdate).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getCandidates(getSearchFilters(nameFilter, page, pageSize, sortColumn, sortDirection, false));
        }).catch((error) => {
            setRefreshCandidate(refreshCandidate * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };
    /* End - Status Update Flow */

    return (
        <div className="card card-white">
            <div className="card-head">
                <a
                    title="Export to Excel"
                    style={{
                        cursor: "pointer",
                        marginLeft: "5px",
                        fontSize: "22px",
                        color: "#217346",
                        verticalAlign: "middle"
                    }}
                    onClick={() => getCandidatesExport(getSearchFilters(nameFilter, page, pageSize, sortColumn, sortDirection, true))}
                >
                    <i className="fa fa-file-excel"></i>
                </a>
            </div>
            <div className="card-body">
                {candidateList.length > 0 && refreshCandidate > 2 &&
                    <AllProfilesGridComponent
                        key={refreshCandidate}
                        candidateList={candidateList}
                        totalSize={candidatePagedList?.totalCount ? candidatePagedList?.totalCount : candidateList.length}
                        currentPage={page + 1}
                        pagesize={pageSize}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                        pageSizesList={pageSizesList}
                        nameFilterValue={nameFilter}
                        timeSlotsList={timeSlots}
                        onStatusUpdate={onStatusUpdateActionHandler}
                        onPageChangeAction={onPageChangeActionHandler}
                        onPageSizeChangeAction={onPageSizeChangeActionHandler}
                        onSortAction={onSortActionHandler}
                        onFilterAction={onFilterActionHandler}
                        onViewRatingAction={onViewRatingActionHandler}
                        onViewRecordingsAction={onViewRecordingsActionHandler}
                        onCandidateViewHistory={onCandidateViewHistoryHandler}
                        onScheduleInterview={onScheduleInterviewActionHandler} />
                }
            </div>
        </div>
    );
};
export default AllProfilesComponent;